export const MILESTONE = 'MILESTONE';
export const MAIN = 'MAIN';
export const EXISTING = 'EXISTING';

export const TEST_TYPE_MAP: any = {
    'half course': 'combined',
}